import { connect } from 'react-redux';

import { setLocationAction } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import Renderer from '.';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  locationSelect: async location => {
    await dispatch(setLocationAction(location));
  },
});

export default connect(null, mapDispatchToProps)(Renderer);
